import { AbstractConnector } from './connector-abstract';

/**
 * This class contains the capability to draw a triple line
 * connector using the coordinate data stored into the model,
 * using the provided graphics object.
 *
 * To draw a triple line connector, the model should have
 * a path with each point the connector should connect to.
 *
 * @author  Nkweti Awa
 * @since   2023-30-08
 */
export class ConnectorTriple extends AbstractConnector {

    /**
     * Draws the wavy connector.
     */
    public draw() {
        const points = this.points || this.model.getPoints();
        if ( !points.length ) {
            return;
        }



        const firstPoint =  points[ 0 ];
        const lastPoint = points[ points.length - 1 ];

        this.moveTo({ x: firstPoint.x, y: firstPoint.y });
        this.lineTo({ x: lastPoint.x, y: lastPoint.y });

        const pos = this.getParallelPoints( firstPoint.x, firstPoint.y, lastPoint.x, lastPoint.y, 10 );
        const p1 = pos[ 0 ];
        const p2 = pos[ 1 ];
        const p3 = pos[ 2 ];
        const p4 = pos[ 3 ];

        this.moveTo( p1 );
        this.lineTo( p2 );

        this.moveTo( p3 );
        this.lineTo( p4);

    }

}

Object.defineProperty( ConnectorTriple, 'name', {
    value: 'ConnectorTriple',
});
